import script from "./myCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./myCenter.vue?vue&type=script&setup=true&lang=js"

import "./myCenter.vue?vue&type=style&index=0&id=0f6946ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6946ff"]])

export default __exports__